import { render, staticRenderFns } from "./ExperienceDetail.vue?vue&type=template&id=65730288&scoped=true"
import script from "./ExperienceDetail.vue?vue&type=script&lang=js"
export * from "./ExperienceDetail.vue?vue&type=script&lang=js"
import style0 from "./ExperienceDetail.vue?vue&type=style&index=0&id=65730288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65730288",
  null
  
)

export default component.exports